import React, { useEffect, useState } from 'react'

import { createStripeClient, getStripeLocale } from '@elo-kit/utils/stripe.utils'
import { Elements, PaymentMethodMessagingElement } from '@stripe/react-stripe-js'
import type { Stripe, StripePaymentMethodMessagingElementOptions } from '@stripe/stripe-js'
import { KLARNA_COUNTRIES } from 'constants/paymentSettingShared.constants'

import './klarna-message.scss'

interface Props {
  pubKey: string
  messageOptions: {
    amount: number
    currency: string
    countryCode: string
  }
  theme: Record<string, any>
}
export const KlarnaMessage = ({ pubKey, messageOptions, theme = {} }: Props) => {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe>>(null)
  const showMessage = KLARNA_COUNTRIES.includes(messageOptions.countryCode)
  const elementsProps = {
    mode: 'setup' as const,
    paymentMethodTypes: ['klarna'],
    appearance: theme,
    locale: getStripeLocale(),
  }
  useEffect(() => {
    if (pubKey) {
      setStripePromise(createStripeClient(pubKey))
    }
  }, [pubKey])

  if (!showMessage || !stripePromise) {
    return null
  }

  return (
    <Elements stripe={stripePromise} options={elementsProps}>
      <PaymentMethodMessagingElement options={messageOptions as StripePaymentMethodMessagingElementOptions} />
    </Elements>
  )
}
